import Api from '@/services/Api'

const HEADERURL = 'cxc/pedidos/';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_AGREGAR_DETALLE_UM = 'agregar_detalle_um';
const ACTION_AGREGAR_DETALLE = 'agregar_detalle';
const ACTION_ELIMINAR_DETALLE = 'eliminar_detalle';
const ACTION_REPORTE_PDF = 'pdf';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params

        });

    },

    getById(codigo) {

        return Api().get(`${HEADERURL}${codigo}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },

    agregar_detalle_um(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_DETALLE_UM}/`, params);
    },

    agregar_detalle(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_DETALLE}/`, params);
    },


    eliminar_detalle(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ELIMINAR_DETALLE}/`, params);

    },

    pdf(id) {

        return Api().get(`${HEADERURL}${id}/${ACTION_REPORTE_PDF}/`);

    },

}